import '../styles/main.css';
import { Link } from 'react-router-dom';
import { Carousel, Card, CardTitle } from 'react-materialize';
import One from '../assets/one.png';
import Two from '../assets/two.png';
import Three from '../assets/three.png';
import Four from '../assets/four.png';
import Five from '../assets/five.png';
import C1 from '../assets/c1.png';
import C2 from '../assets/c2.png';
import C3 from '../assets/c3.png';
import C4 from '../assets/c4.png';
import C5 from '../assets/c5.png';

export default function Landing() {
    
    return (
        <div>
            <Carousel
                className='carousal'
                carouselId="Carousel-35"
                images={[
                    C1, C2, C3, C4, C5
                ]}
                options={{
                    fullWidth: true,
                    indicators: true,
                }}
            />
            <div className='category-one'>
                <h5 style={{margin: '0 0 0 1rem'}}>TRENDING IN WESTERN WEAR</h5>
                <div className='category-one-items'>
                    <div className='category-one-items-individual'>
                        <Link to='/shop'>
                            <img src={One} />
                        </Link>
                    </div>
                    <div className='category-one-items-individual'>
                        <Link to='/shop'>
                            <img src={Two} />
                        </Link>
                    </div>
                    <div className='category-one-items-individual'>
                        <Link to='/shop'>
                            <img src={Three} />
                        </Link>
                    </div>
                    <div className='category-one-items-individual'>
                        <Link to='/shop'>
                            <img src={Four} />
                        </Link>
                    </div>
                    <div className='category-one-items-individual'>
                        <Link to='/shop'>
                            <img src={Five} />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}